import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

export const BettingPatterns = () => {
  const patterns = [
    {
      title: 'Red / Black',
      description: 'Simple color-based selection across the 18 red or 18 black pockets.',
      color: 'bg-gradient-to-br from-danger-500/20 to-charcoal-900/50',
      border: 'border-danger-500/30'
    },
    {
      title: 'Odd / Even',
      description: 'Select odd or even numbers, excluding the green zero.',
      color: 'bg-gradient-to-br from-blue-500/20 to-charcoal-900/50',
      border: 'border-blue-500/30'
    },
    {
      title: 'High / Low',
      description: 'Choose the lower half, 1–18, or the higher half, 19–36.',
      color: 'bg-gradient-to-br from-purple-500/20 to-charcoal-900/50',
      border: 'border-purple-500/30'
    },
    {
      title: 'Dozens',
      description: 'Select one of the three groups of twelve consecutive numbers.',
      color: 'bg-gradient-to-br from-gold-500/20 to-charcoal-900/50',
      border: 'border-gold-500/30'
    }
  ];

  return (
    <section className="py-24 bg-charcoal-800 border-t border-gray-800">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-white mb-6"
          >
            Popular Betting <span className="text-gold-500">Patterns</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-gray-400 text-lg leading-relaxed mb-6"
          >
            Common ways players group their selections at the Roulette table.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-4 py-2 bg-charcoal-900 border border-gray-700 rounded-full"
          >
            <AlertCircle className="w-4 h-4 text-gold-500" />
            <span className="text-xs font-bold tracking-widest text-gray-400">EDUCATIONAL / DEMO ONLY</span>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {patterns.map((pattern, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`p-8 rounded-2xl border ${pattern.border} ${pattern.color} hover:shadow-[0_0_20px_rgba(255,255,255,0.05)] transition-all group`}
            >
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-gold-400 transition-colors">{pattern.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {pattern.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
